module.exports = __webpack_public_path__ + "img/logo.ece06887.jpg";